/**
 * 「다른 사람들은 어땠나」.
 *
 * 연구·통계 동의의 대가로 돌려주는 값이다. 동의율을 올리는 정당한 방법은
 * 체크박스를 미리 켜 두는 게 아니라 **동의할 이유를 만드는 것**이다.
 * 그리고 이 숫자는 동의한 사람들이 만든 것이라, 주고받는 관계가 실제로 성립한다.
 *
 * 승패나 점수를 만들지 않는다. 매기는 순간 사람들이 방어적으로 굳고
 * 입장 이동이 사라진다 — 그러면 이 서비스가 팔 게 없어진다.
 */

/** 이 정도 차이는 「비슷하다」고 본다. 1~2점 차이를 다르다고 말하면 없는 의미를 만든다. */
const SAME = 5;

/**
 * 나와 남을 **서술**한다. 판정하지 않는다.
 *
 * 「더 잘했다」는 말을 만들지 않는 게 핵심이다. 확신이 덜 흔들린 게 좋은 것도
 * 아니다 — 회피가 있는데 확신만 버텼으면 그건 답을 안 한 것이다.
 */
export function compareLine(mine, peer) {
  if (!peer) return null;
  const gap = mine.delta - peer.delta;

  if (Math.abs(gap) < SAME) return "다른 분들과 비슷하게 움직였어요";
  return gap > 0
    ? "다른 분들보다 덜 흔들렸어요"
    : "다른 분들보다 많이 흔들렸어요";
}

/** 부호가 곧 의미다. 올랐는지 내렸는지가 먼저 보여야 한다. */
export const signed = (v) =>
  !Number.isFinite(v) ? "—" : `${v > 0 ? "+" : v < 0 ? "−" : ""}${Math.abs(v).toFixed(1)}`;
